import { Award, Briefcase, Star, MapPin } from "lucide-react";
import { ASSETS } from "@/lib/site";

export const Director = () => {
  return (
    <section
      id="director"
      data-testid="director-section"
      className="relative scroll-mt-nav py-28 md:py-36 bg-[#0A0D14] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-[#1E3A8A]/30 blur-[120px]" />
        <div className="absolute -bottom-40 -left-40 w-[480px] h-[480px] rounded-full bg-[#2DD4BF]/15 blur-[120px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-6">02 · The Director</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white">
              Nagaveni <span className="italic text-gradient-gold">Santhosha</span>
            </h2>
            <p className="mt-3 text-slate-300 text-lg">
              Producer · Director · Lead Actor — Founder, AU Movies.
            </p>

            <div className="mt-8 relative rounded-3xl overflow-hidden border border-white/10 hover-lift">
              <img
                src={ASSETS.director}
                alt="Nagaveni Santhosha"
                className="w-full h-[520px] object-cover"
                data-testid="director-portrait"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 text-[#2DD4BF] text-xs tracking-[0.25em] uppercase">
                  <MapPin size={14} /> Bangalore, India
                </div>
                <p className="font-serif text-2xl text-white mt-2">
                  "From the South to the screens of Asia."
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Briefcase, k: "12+", v: "Years in Bollywood" },
                { icon: Award, k: "7", v: "Films as AD / Associate" },
                { icon: Star, k: "3 in 1", v: "Producer · Director · Actor" },
                { icon: MapPin, k: "Bengaluru", v: "Headquartered" },
              ].map(({ icon: Icon, k, v }) => (
                <div key={v} className="glass-card rounded-2xl p-6 hover-lift" data-testid={`director-stat-${k.replace(/\s/g, '-')}`}>
                  <Icon size={20} strokeWidth={1.5} className="text-[#2DD4BF]" />
                  <p className="font-serif text-3xl text-white mt-4">{k}</p>
                  <p className="text-xs tracking-[0.18em] uppercase text-slate-400 mt-2">{v}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 glass-card rounded-2xl p-8">
              <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37]">Vision</p>
              <p className="text-slate-200 text-lg leading-relaxed mt-4 font-serif italic">
                "I spent twelve years standing behind seven films, learning the craft of telling
                Indian stories at scale. AU Movies is my answer to a single question — can a story
                born in Karnataka speak natively to Mumbai, Madras, Manila and beyond? Zero to One
                is that answer, told in six languages, shot as one."
              </p>
              <p className="text-sm text-slate-400 mt-6">
                — Nagaveni Santhosha, Founder & Director
              </p>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};
